<template>
  <div>
    <h2 class="text-xl font-semibold mb-4">Välj biljetter</h2>

    <div
      v-for="ticket in event.ticketTypes"
      :key="ticket.name"
      class="border rounded p-4 mb-4 flex justify-between items-center"
    >
      <div>
        <p class="font-medium">{{ ticket.name }}</p>
        <p class="text-gray-500 text-sm">{{ ticket.price }} kr</p>
        <p class="text-gray-400 text-xs">Antal kvar: {{ ticket.quantity }}</p>
      </div>

      <div class="flex items-center space-x-2">
        <button
          class="px-2 py-1 bg-gray-200 rounded"
          @click="decrement(ticket)"
        >-</button>
        <span class="w-6 text-center">{{ ticket.selected || 0 }}</span>
        <button
          class="px-2 py-1 bg-blue-500 text-white rounded"
          @click="increment(ticket)"
        >+</button>
      </div>
    </div>

    <button
      class="mt-4 bg-indigo-600 text-white px-4 py-2 rounded w-full hover:bg-indigo-700"
      @click="$emit('next')"
    >
      Nästa
    </button>
  </div>
</template>

<script>
export default {
  props: ['event'],
  methods: {
    increment(ticket) {
      ticket.selected = (ticket.selected || 0) + 1;
    },
    decrement(ticket) {
      if (ticket.selected > 0) ticket.selected--;
    },
  },
};
</script>
